module.exports = __webpack_public_path__ + "static/media/primary.1545e144.jpg";